// extracted by css-extract-rspack-plugin
export default {"cls1":"PaywallPage-cls1_VsX","cls2":"PaywallPage-cls2_bLh PaywallPage-cls1_VsX"};